import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class PolyVerticalBorder extends AbstractProvidedClass {
    defaultTolerance = this.mobile ? 12 : 7;
    lineLength = 5;

    constructor(provider, parent, corner1, corner2) {
        super(provider);
        this.parent = parent;
        this.corner1 = corner1;
        this.corner2 = corner2;
    }

    display() {
        this.p.stroke(0);
        this.p.strokeWeight(1);
        this.p.color(0);
        for (let i = Math.min(this.corner1.currentY, this.corner2.currentY);
            i <= Math.max(this.corner1.currentY, this.corner2.currentY);
            i += (this.lineLength) * 2
        ) {
            this.p.line(
                this.corner1.currentX,
                i,
                this.corner1.currentX,
                i + this.lineLength,
            );
        }
    }

    hovered() {
        return this.currentMinX <= this.view.currentX
            && this.currentMaxX >= this.view.currentX
            && this.currentMinY <= this.view.currentY
            && this.currentMaxY >= this.view.currentY;
    }

    drag(dx, dy) {
        this.move(dx, dy);
    }

    move(dx, dy) {
        if (dx == 0) {
            return;
        }
        this.corner1.absX += dx;
        this.corner2.absX += dx;
        this.parent.center.absX += dx / 2;
        this.parent.coordinates.map(c => {
            c.absX = this.parent.absMinX + this.parent.absWidth * c.xRatio;
        })
        this.updateInputs();
        this.parent.row.updateImg();
    }

    mouseOver() {
        if (!this.hovered()) {
            return false;
        }

        this.cursor.resizeHorizontal();
        return true;
    }

    updateInputs() {
        let multiInput = this.getTab('info').input.multiInput;
        for (let i = 0; i < this.parent.length; i++) {
            let input = multiInput.getInput(i);
            input.value(this.parent.segmentLength(i));
        }
    }

    get absX() {
        return this.corner1.absX;
    }

    get currentMinX() {
        return this.corner1.currentX - this.tolerance;
    }

    get currentMaxX() {
        return this.corner1.currentX + this.tolerance;
    }

    get currentMinY() {
        return Math.min(this.corner1.currentY, this.corner2.currentY);
    }

    get currentMaxY() {
        return Math.max(this.corner1.currentY, this.corner2.currentY);
    }

    get tolerance() {
        return Math.min(this.defaultTolerance, this.parent.currentWidth / 10)
    }
}
